import * as go from "gojs";
import { $, workflowEditorConstants } from "./WorkflowEditorConstants";
import { defaultImage } from "./workflowImages";

const getTextStyle = (size: number, color: string = "#2e2e2e") => ({
  font: `${size} 'Calibri', sans-serif`,
  stroke: "#2e2e2e"
});

export const templateNormal = () =>
  $(
    go.Panel,
    go.Panel.Auto,
    $(
      go.Panel,
      go.Panel.Vertical,
      { stretch: go.GraphObject.Horizontal, margin: new go.Margin(10, 0, 20, 0) },
      $(
        go.Picture,
        {
          desiredSize: new go.Size(
            workflowEditorConstants.nodeSize - 20,
            (workflowEditorConstants.nodeSize - 45) / 2
          ),
          imageStretch: go.GraphObject.Uniform
        },
        new go.Binding("source", "icon", value => (value ? value.url : defaultImage.url))
      ),
      $(
        go.TextBlock,
        {
          margin: new go.Margin(10, 0, 0, 0),
          width: workflowEditorConstants.nodeSize - 20,
          height: (workflowEditorConstants.nodeSize - 60) / 2,
          overflow: go.TextBlock.OverflowEllipsis,
          alignment: go.Spot.Center,
          ...getTextStyle(10.5)
        },
        new go.Binding("text", "description")
      )
    )
  );

export const templateSmall = () =>
  $(
    go.Picture,
    {
      desiredSize: new go.Size(
        workflowEditorConstants.nodeSize - 20,
        workflowEditorConstants.nodeSize / 2
      ),
      imageStretch: go.GraphObject.Uniform
    },
    new go.Binding("source", "icon", value => (value ? value.url : ""))
  );

export const linkTemplate = () =>
  $(
    go.Panel,
    go.Panel.Auto,
    new go.Binding("visible", "label", text => text != null && text.length > 0),
    $(go.Shape, "Rectangle", {
      stroke: "black",
      strokeDashArray: [3, 5],
      fill: "white"
    }),
    $(go.TextBlock, new go.Binding("text", "label"), {
      name: "DEFAULT_LINK_LABEL_TEXT",
      margin: new go.Margin(2, 7, 2, 7),
      ...getTextStyle(10)
    })
  );
